<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="700" v-if="dialog" scrollable>
			<v-card>
				<v-card-title class="headline" v-if="propAdd=='tambah'">Tambah Driver</v-card-title>
				<v-card-title class="headline" v-else>Edit Driver</v-card-title>
				<v-card-text class="pb-2">
					<v-form ref="formDriver">

						<v-card
							outlined
							class="pa-2 mb-4"
							v-if="propAdd=='tambah'"
						>
							<v-card-subtitle class="pa-2 font-weight-bold">
								Info Akun Login
							</v-card-subtitle>
							<v-row class="ma-0">
								<v-col cols="6" class="text-center">
									<div>
										<v-text-field label="Username" validate-on-blur outlined class="text-body-1" prepend-inner-icon="mdi-account-lock-outline" hide-details="auto" dense color="primary lighten-1" v-model="params.username" @focus="() => responseError.username=''" :error-messages="responseError.username" :rules="rules.username" hint="Username minimal 6 karakter"></v-text-field>
									</div>
								</v-col>
								<v-col cols="6" class="text-center">
									<div>
										<v-text-field label="Password" validate-on-blur outlined class="text-body-1"  prepend-inner-icon="mdi-lock-outline" hide-details="auto" dense color="primary lighten-1" type="password" v-model="params.password" @focus="() => responseError.password=''" :error-messages="responseError.password" :rules="rules.password"></v-text-field>
									</div>
								</v-col>
							</v-row>
						</v-card>

						<v-card
							outlined
							class="pa-2 mb-2"
						>
							<v-card-subtitle class="pa-2 font-weight-bold">
								Detail Biodata Driver
							</v-card-subtitle>
							<v-row class="ma-0">
								<v-col cols="6" class="text-center">
									<div>
										<v-text-field label="Nama Driver" validate-on-blur outlined class="text-body-1" hide-details="auto" dense color="primary lighten-1" v-model="params.name" @focus="() => responseError.name=''" :error-messages="responseError.name" :rules="rules.name"></v-text-field>
									</div>
								</v-col>
								<v-col cols="6" class="text-center">
									<div>
										<v-text-field label="No. SIM" validate-on-blur outlined class="text-body-1" hide-details="auto" dense color="primary lighten-1" v-model="params.passport" @keypress="onlyNumber" @focus="() => responseError.passport=''" :error-messages="responseError.passport" :rules="rules.passport"></v-text-field>
									</div>
								</v-col>
								<v-col cols="6" class="text-center">
									<div>
										<v-autocomplete label="Jenis Kelamin" validate-on-blur :items="optionGender" item-text="label" item-value="value" outlined class="text-body-1" hide-details="auto" dense no-data-text="Tidak ada data" color="primary lighten-1" v-model="params.gender" @focus="() => responseError.gender=''" :error-messages="responseError.gender" :rules="rules.gender"></v-autocomplete>
									</div>
								</v-col>
								<v-col cols="6" class="text-center"></v-col>
								<v-col cols="6" class="text-center">
									<div>
										<v-text-field label="Tempat Lahir" validate-on-blur outlined class="text-body-1" hide-details="auto" dense color="primary lighten-1" v-model="params.place_of_birth" @focus="() => responseError.place_of_birth=''" :error-messages="responseError.place_of_birth" :rules="rules.place_of_birth"></v-text-field>
									</div>
								</v-col>
								<v-col cols="6" class="text-center">
									<div>
										<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="35" transition="scale-transition" offset-y min-width="290px">
											<template v-slot:activator="{ on, attrs }">
												<v-text-field label="Tanggal Lahir" outlined hide-details="auto" dense prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" :value="convertDate(params.date_of_birth)" @focus="() => responseError.date_of_birth=''" :error-messages="responseError.date_of_birth" :rules="rules.date_of_birth"></v-text-field>
											</template>
											<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="menu = false" v-model="params.date_of_birth"></v-date-picker>
										</v-menu>
									</div>
								</v-col>
								<v-col cols="6" class="text-center">
									<div>
										<v-text-field label="Email" validate-on-blur outlined class="text-body-1" hide-details="auto" dense color="primary lighten-1" v-model="params.email" @focus="() => responseError.email=''" :error-messages="responseError.email" :rules="rules.email"></v-text-field>
									</div>
								</v-col>
								<v-col cols="6" class="text-center">
									<div>
										<v-text-field label="No. Handphone" validate-on-blur outlined class="text-body-1" hide-details="auto" dense color="primary lighten-1" v-model="params.mobilephone" @keypress="onlyNumber" @focus="() => responseError.mobilephone=''" :error-messages="responseError.mobilephone" :rules="rules.mobilephone"></v-text-field>
									</div>
								</v-col>
								<v-col cols="12" class="text-center">
									<div>
										<v-textarea label="Alamat" validate-on-blur outlined class="text-body-1" hide-details="auto" dense color="primary lighten-1" height="100" no-resize v-model="params.address" @focus="() => responseError.address=''" :error-messages="responseError.address" :rules="rules.address"></v-textarea>
									</div>
								</v-col>
							</v-row>
						</v-card>
					</v-form>
				</v-card-text>
				<v-card-actions class="py-3 px-6 pb-5">
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="modalHide()">Batal</v-btn>
					<v-btn dark color="primary lighten-1" depressed class="text-capitalize" @click="simpan()">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

function validateUsername(username) {
  var re = new RegExp('^(?=.{4,50}$)(?=.*[a-z])[a-z0-9_]+$');
  return re.test(username);
}

export default {
	data () {
		return {
			dialog: false,
			menu:false,
			params: {
				id: '',
				username: '',
				password: '',
				passport : '',
				name : '',
				place_of_birth : '',
				date_of_birth: '',
				email: '',
				mobilephone: '',
				gender: '',
				address: ''
			},
			rules:{
        username: [
					v => !!v || 'Tidak boleh kosong',
					v => v.length > 5 || 'Username minimal 6 karakter',
					v => v.length <= 20 || 'Username maksimal 20 karakter',
					v => validateUsername(v) || 'Hanya diijinkan menggunakan huruf (a-z), angka, dan underscore'
        ],
        password: [
					v => !!v || 'Tidak boleh kosong',
					v => v.length >= 6 || 'Password minimal 6 karakter',
        ],
        passport: [
          v => !!v || 'Tidak boleh kosong',
        ],
        name: [
          v => !!v || 'Tidak boleh kosong',
				],
				place_of_birth: [
          v => !!v || 'Tidak boleh kosong',
				],
				date_of_birth: [
          v => !!v || 'Tidak boleh kosong',
				],
				email: [
					v => !!v || 'Tidak boleh kosong',
					v => !!validateEmail(v) || 'Format Email tidak sesuai',
				],
				mobilephone: [
					v => !!v || 'Tidak boleh kosong',
					v => v.length >= 10 && v.length <= 15 || 'No. handphone tidak sesuai format'
				],
				gender: [
          v => !!v || 'Tidak boleh kosong',
				],
				address: [
          v => !!v || 'Tidak boleh kosong',
				]
      }
		}
	},
	props: {
		propAdd: String,
		val: Object,
	},
	computed: {
		...mapState('driver', ['optionGender', 'responseError']),
	},
	methods: {
		...mapActions('driver', ['getOptionGender']),

		modalShow(data) {
			this.dialog = true
			Object.assign( this.params , data )
		},
		modalHide() {
			this.dialog = false
			this.reset()
		},
		simpan() {
			if (this.$refs.formDriver.validate()) {
				this.$emit('action', this.params)
			}
		},
		reset () {
			this.params.id = ''
			this.params.username = ''
			this.params.password = ''
			this.params.name = ''
			this.params.passport  = ''
			this.params.place_of_birth  = ''
			this.params.date_of_birth  = ''
			this.params.email  = ''
			this.params.mobilephone  = ''
			this.params.gender  = ''
			this.params.address  = ''
		},
	},
	watch: {
		val () {
			if (Object.keys(this.val).length > 0) {
				this.params.id = this.val.driver_id
				this.params.name  = this.val.driver_name
				this.params.passport = this.val.driver_passport
				this.params.place_of_birth  = this.val.driver_place_of_birth
				this.params.date_of_birth = this.val.driver_date_of_birth
				this.params.email  = this.val.driver_email
				this.params.mobilephone  = this.val.driver_mobilephone
				this.params.gender = this.val.driver_gender
				this.params.address = this.val.driver_address
			} else {
				this.reset()
			}
		}
	},
	created() {
		this.getOptionGender()
	}
};
</script>